<template>
    <AuthLayout>
        <form @submit.prevent="submit">

            <h2 class="font-bold text-lg mb-4">{{ __('admins::auth.reset_password_title') }}</h2>

            <div v-if="$page.props.flash.success" class="text-green-700">
                {{ $page.props.flash.success }} <br><br>

                <InertiaLink :href="$route('admin::auth.create')" class="flex items-center font-bold">
                    {{ __('admin::auth.go_to_login') }}
                    <ArrowNarrowRightIcon class="w-4 h-4" />
                </InertiaLink>
            </div>

            <div v-else>
                <FormGroup :label="__('admin::labels.email')" :error="errors.email">
                    <Input name="email" type="email" :has-error="exists(errors.email)" v-model="form.email" :required="true" autocomplete="username" autofocus />
                </FormGroup>

                <FormGroup :label="__('admin::labels.password')" :error="errors.password">
                    <Input name="password" type="password" :has-error="exists(errors.password)" v-model="form.password" :required="true" autocomplete="new-password" />
                </FormGroup>

                <FormGroup :label="__('admin::labels.password_confirmation')" :error="errors.password_confirmation">
                    <Input name="password_confirmation" type="password" :has-error="exists(errors.password_confirmation)" v-model="form.password_confirmation" :required="true" autocomplete="new-password" />
                </FormGroup>

                <div class="flex items-center justify-end mt-2">
                    <Button :block="true" :loading="form.processing" class="!py-3">
                        {{ __('admin::auth.reset_password_cta') }}
                    </Button>
                </div>
            </div>
        </form>
    </AuthLayout>
</template>

<script>
import {ArrowNarrowRightIcon} from "@heroicons/vue/solid";

export default {
    components: {
        ArrowNarrowRightIcon,
    },
    props: {
        errors: Object,
        token: String,
    },
    data() {
        return {
            form: this.$inertia.form({
                email: '',
                password: '',
                password_confirmation: '',
                token: this.token,
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.$route('admin::reset-password.submit'));
        }
    }
}
</script>
